<div class="modal-container">
    <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
        <app-step-progressbar>
            <app-progress-step>
                <app-select-vendor-tab [data]="data"></app-select-vendor-tab>
            </app-progress-step>
            <app-progress-step>
                <app-confirm-selection-tab [data]="data"></app-confirm-selection-tab>
            </app-progress-step>
            <app-progress-step>
                <app-send-request-tab [data]="data"></app-send-request-tab>
            </app-progress-step>
        </app-step-progressbar>
              </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex gap-3">
            <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
                class="" (click)="activeModal.close({title,confirm:false})"
                [buttonLable]="enumButtonName.CANCEL"></app-button>
                <app-button  [buttonType]="'button'" [button_2]="true"
                [buttonClass]="false ? 'button-primary button font-11' : 'button-info button popup-button'"
                [ngClass]="{'d-none': isDisable('Previous'), 'd-block': !isDisable('Previous')}"
                 [buttonLable]="'Previous'"
                [inputReadonly]="isDisable('Previous')"
                (click)="onPrevClick()"></app-button>
                <app-button  [buttonType]="'button'" [button_2]="true"
                [buttonClass]="false ? 'button-primary button font-11' : 'button-info button popup-button'"
                class="" [buttonLable]="'Next'"
                [ngClass]="{'d-none': isDisable('Next'), 'd-block': !isDisable('Next')}"
                (click)="onNextClick()"></app-button>
                <app-button  [buttonType]="'button'" [button_2]="true"
                [buttonClass]="true ? 'button-primary button font-11' : 'button-info button popup-button'"
                [ngClass]="{'d-none': !isDisable('Next'), 'd-block': isDisable('Next')}"
                class="" [buttonLable]="'Send'" (click)="onSendClick()"
                ></app-button>
        
        </div>
    </div>
</div>